import { closeApp } from "../actions/appStatus";

export function handleSendMessage(ev, data) {
  if (!ev.detail.action) console.error("action is mandatory");

  let poster = window.parent;
  switch (ev.detail.action) {
    case "close":
      window.loadedCacheProviderData = false;
      window.loadedCacheUserData = false;
      window.appIsClosing = true;
      setTimeout(() => {
        window.dispatch(closeApp());
      }, 0); //execute in next loop to give time to app to close
      setTimeout(() => {
        poster.postMessage(
          JSON.stringify({
            action: "close"
          }),
          "*"
        );
      }, 2); //execute in next loop to give time to app to close
      break;
    //this is commented because it causes a double load of data in the calendar when saving an appointment
    // case 'refresh':
    //   poster.postMessage(JSON.stringify({
    //     action : 'refresh'
    //   }),'*');
    //   break;
    default:
      console.info("invalid action dispatched");
  }
}

let poster = {};
if (window.parentContainer) {
  poster = window.parentContainer;
} else {
  poster = parent;
}
poster.postMessage(
  JSON.stringify({
    action: "sayhiitsmebookingform"
  }),
  "*"
);
